export default "__VITE_ASSET__6317249f__"